module.exports = __webpack_public_path__ + "static/media/menu-northstar-active.ad8c8437.svg";